import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { useBreadcrumbs } from '../layout/breadcrumbsContext/useBreadcrumbs/useBreadcrumbs'

import { ReportFlagGate } from './ReportFlagGate'
import { getModuleReports, ReportModule, reportDetailPath } from './reportsConfig'
import { Anchor, Card, Flex, Grid, Heading, Icon, Text } from '@percent/lemonade'

type ReportsProps = {
  module: ReportModule
}

/** The reports list page for a module: a card per available report, linking through. */
export function Reports({ module }: Readonly<ReportsProps>) {
  const { t } = useTranslation()

  useBreadcrumbs([{ label: t('breadcrumb.reports') }])

  const reports = getModuleReports(module)

  return (
    <Flex direction="column" gap="lg" w="100%" data-testid="reports-container">
      <Flex direction="column" gap="xs">
        <Heading level="h2">{t('reports.title')}</Heading>
        <Text size="small">{t('reports.description')}</Text>
      </Flex>
      {reports.length === 0 ? (
        <Text size="small">{t('reports.emptyState')}</Text>
      ) : (
        <Grid gutter="md" w="100%" data-testid="reports-list">
          {reports.map(report => (
            <ReportFlagGate key={report.slug} report={report}>
              <Grid.Col span={{ base: 12, sm: 6 }}>
                <Anchor component={Link} to={reportDetailPath(module, report.slug)} underline="never" c="inherit">
                  <Card testId={`report-card-${report.slug}`}>
                    <Flex gap="sm" p="lg" w="100%" align="flex-start">
                      <Icon name="report" size={5} color="goodstack" />
                      <Flex direction="column" gap="xs">
                        <Heading level="h5">{t(report.titleKey)}</Heading>
                        <Text size="small">{t(report.descriptionKey)}</Text>
                      </Flex>
                    </Flex>
                  </Card>
                </Anchor>
              </Grid.Col>
            </ReportFlagGate>
          ))}
        </Grid>
      )}
    </Flex>
  )
}
